
import { DaVolumeComponent } from './components/da-volume/da-volume.component';
import { DaCostContributionsComponent } from './components/da-cost-contributions/da-cost-contributions.component';
import { DaRmPmComponent } from './components/da-rm-pm/da-rm-pm.component';
import { DaFactorySummaryComponent } from './components/da-factory-summary/da-factory-summary.component';
import { FactoryList } from './../waste-dashboard/model/waste-dashboard-model.model';
import { BookMarkList, FactorySummary, FactorySummaryDetails, TrendsResponse } from './models/factory-summary';
import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SelectLineComponent } from 'src/app/shared/components/select-line/select-line.component';
import { FactorySelectionModalComponent } from './components/factory-selection-modal/factory-selection-modal.component';
import { DataAnalyticsService } from './services/data-analytics.service';
import moment from 'moment';
import { DaTrendsComponent } from './components/da-trends/da-trends.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/shared/service/data.service';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { OEEAndChangeOver } from './models/factory-summary';
import { Subject, Subscription } from 'rxjs';
import { DaCommentsComponent } from 'src/app/shared/components/da-comments/da-comments.component';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service.service';
import { MsalService } from '@azure/msal-angular';
@Component({
  selector: 'app-data-analytics',
  templateUrl: './data-analytics.component.html',
  styleUrls: ['./data-analytics.component.scss']
})
export class DataAnalyticsComponent implements OnInit, OnDestroy {

  @ViewChild(DaFactorySummaryComponent) factorySummaryComponent: DaFactorySummaryComponent;
  @ViewChild(DaRmPmComponent) daRmPmComponent: DaRmPmComponent;
  @ViewChild(DaTrendsComponent) daTrendsComponent: DaTrendsComponent;
  @ViewChild(DaCostContributionsComponent) daCostContribution: DaCostContributionsComponent;
  @ViewChild(DaVolumeComponent) daVolumeComponent: DaVolumeComponent;
  @ViewChild(DaCommentsComponent) daCommentsComponent: DaCommentsComponent;

  factorySummary: FactorySummaryDetails;
  showDashboard: boolean;
  selectedDACluster: any;
  selectedDAFactory: any;
  fromDate: any;
  toDate: any;
  clusterIdFromURL = '';
  factoryIdFromURL = '';
  currrentFilter = 'month';
  currentDate: any;
  filterApplied: boolean;
  isCurrentURLSaved = false;
  userDtls: any;
  public bookmarkList: BookMarkList[] = [];
  level: string;
  subscription: Subscription;
  oeeAndChangeOverData: OEEAndChangeOver[] = [];
  public trendsData: TrendsResponse = {};

  isLoading = false;
  isLoadingTrend = false;

  message = '';
  messageTrend = '';
  currencyData: any = {
    currencyRate: '',
    yUnit: '',
    symbolCode: '',
    label: ''
  };

  isShowCommentBox = false;
  lineId: string;
  lineName: string;
  zerobasedtarget: any;

  // subscriptions
  actualConsumptionSubscription: Subscription;
  oeeAndChangeOverSubscription: Subscription;
  factoryImageSubscription: Subscription;
  getBookmarkSubscription: Subscription;
  latestDataRefreshDateSubscription: Subscription;
  uniqueClusterList: any[];
  constructor(
    public dialog: MatDialog,
    private daService: DataAnalyticsService,
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService,
    private dataSer: DataService,
    public authService: MsalService

  ) {
    this.route.queryParams.subscribe(params => {
      const cluster = 'cluster';
      const factory = 'factory';
      const FromDate = 'FromDate';
      const ToDate = 'ToDate';

      this.clusterIdFromURL = params[cluster];
      this.factoryIdFromURL = params[factory];
      this.fromDate = params[FromDate];
      this.toDate = params[ToDate];
      this.level = params.level;
      this.lineId = params.LineId;
      this.lineName = params.LineName;

      if (this.clusterIdFromURL && this.factoryIdFromURL) {
        this.showDashboard = true;
      } else {
        this.showDashboard = false;
      }
    });
  }

  ngOnInit() {
    this.message = 'Sub-Region & Factory not yet selected.';
    this.currentDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
    this.daService.clearSelectedDA();
    this.selectedDACluster = this.getLocalStorageData('selectedDACluster');
    this.selectedDAFactory = this.getLocalStorageData('selectedDAFactory');
    if (this.clusterIdFromURL && this.clusterIdFromURL !== '') {
      // cluster and factory already selected
      const userFactory = this.getLocalStorageData('dfos.userfactory.data');

      if (userFactory && userFactory[0]) {
        /* const clusterData = userFactory.filter(cluster => cluster.id === this.clusterIdFromURL);
        if (clusterData && clusterData[0] && clusterData[0].factoryList && clusterData[0].factoryList[0]) {
          const factoryData = clusterData[0].factoryList.filter(factory => factory.factoryId === this.factoryIdFromURL); */
        this.uniqueClusterList = [];
        let factoryData;
        for (let index = 0; index < userFactory.length; index++) {
          if (userFactory[index].id === this.clusterIdFromURL) {
            userFactory.forEach((entry) => {
              entry.factoryList.forEach(element => {
                element['clusterIdData'] = entry.name;
              });
            });
            this.uniqueClusterList = [...this.uniqueClusterList, ...userFactory[index].factoryList];
          }
        }
        this.uniqueClusterList.forEach(element => {
          if (element.factoryId === this.factoryIdFromURL) {
            factoryData = element;
          }
        });
        if (this.uniqueClusterList && this.uniqueClusterList[0] && this.uniqueClusterList[0] && this.uniqueClusterList[0].factoryId) {
          if (factoryData) {

            const selectedDACluster = {
              id: this.clusterIdFromURL,
              name: factoryData.clusterIdData
            };

            const selectedDAFactory = {
              id: {
                $oid: factoryData.id.$oid
              },
              factoryId: this.factoryIdFromURL,
              name: factoryData.name
            };

            const selectedDate = {
              startOfMonth: this.fromDate,
              endOfMonth: this.toDate
            };
            this.currrentFilter = sessionStorage.getItem('selectedPeriod');
            if (this.currrentFilter === 'quarter') {
              this.currentDate = new Date(this.fromDate) + '|' + new Date(this.toDate);
            } else {
              this.currentDate = new Date(this.fromDate);
            }
            // const diff = Number(Number(this.toDate.split('-')[1]) - Number(this.fromDate.split('-')[1]));
            // if (diff > 2) {
            //   this.currrentFilter = 'year';
            //   this.currentDate = new Date(this.fromDate);
            // } else if (diff > 0) {
            //   this.currrentFilter = 'quarter';
            //   this.currentDate = new Date(this.fromDate) + '|' + new Date(this.toDate);
            // } else {
            //   this.currrentFilter = 'month';
            //   this.currentDate = new Date(this.fromDate);
            // }
            this.filterApplied = true;
            this.setLocalStorageData('selectedDATimeFilter', selectedDate);
            this.setLocalStorageData('selectedDACluster', selectedDACluster);
            this.setLocalStorageData('selectedDAFactory', selectedDAFactory);
            this.setFactorySummary();
          } else {
            this.showDashboard = false;
            this.message = 'You are not authorized to view the requested factory';
          }
        } else {
          this.showDashboard = false;
          this.message = 'You are not authorized to view the requested factory';
        }
      }


    } else {
      this.checkUserAccess();
    }

    //  if (this.auth.checkIsAuthticated) {
    //    this.userDtls = this.auth.getAllAccountInfo;
    this.getBookmarkData();
    //  }

    this.getLatestDataRefreshDate();

    this.subscription = this.route.queryParams.subscribe(params => {
      if (params.level && params.factory) {
        this.getActualConsumptionData(params);
      }
      if (params.level && params.factory && params.level === 'line') {
        this.getOEEAndChangeOverData(params);
      }
    });
  }

  getActualConsumptionData(params) {
    const reqParams: any = {
      FromDate: params.FromDate,
      ToDate: params.ToDate,
      FactoryId: params.factory,
      ClusterId: params.cluster,
      Level: this.level
    };
    if (reqParams.Level === 'line') {
      reqParams.LineId = params.LineId;
    }

    this.isLoadingTrend = true;
    this.messageTrend = 'Loading...';
    this.actualConsumptionSubscription = this.daService.getActualConsumption(reqParams)
      .subscribe((data) => {
        if (data && data.actualConsumption && data.actualConsumptionWastePercentage) {

          this.isLoadingTrend = false;
          this.trendsData = data;
        } else {
          this.messageTrend = 'Data not available.';
        }
      }, err => {
        this.messageTrend = 'Data not available.';
      });
  }

  getOEEAndChangeOverData(params) {
    const req = {
      FromDate: params.FromDate,
      ToDate: params.ToDate,
      FactoryId: params.factory,
      LineId: params.LineId,
      Level: 'line',
    };
    this.isLoading = true;
    this.message = 'Loading...';
    this.oeeAndChangeOverSubscription = this.daService.getOEEAndChangeOver(req)
      .subscribe((res: OEEAndChangeOver[]) => {
        if (res && res.length > 0) {
          this.isLoading = false;
          this.oeeAndChangeOverData = res;
        } else {
          this.message = 'Data not available.';
        }
      }, err => {
        this.message = 'Data not available.';
      });
  }

  checkUserAccess() {
    if (this.selectedDACluster && this.selectedDAFactory) {
      this.setFactorySummary();
    } else {
      const savedData = this.getLocalStorageData('dfos.userfactory.data');
      if (savedData && savedData.length > 0) {
        let factoryCount = 0;
        for (const c of savedData) {
          if (c.factoryList && c.factoryList.length > 0) {
            for (const factory of c.factoryList) {
              factoryCount++;
              if (factoryCount >= 2) { break; }
            }
          }
        }
        if (factoryCount === 1) {
          for (const cluster of savedData) {
            if (cluster.factoryList && cluster.factoryList.length > 0) {
              this.setLocalStorageData('selectedDACluster', cluster);
              this.setLocalStorageData('selectedDAFactory', cluster.factoryList[0]);
              this.setFactorySummary();
            }
          }
        } else {
          this.showFactorySelectionPopup();
        }
      }
    }
  }

  setDADate() {
    const daDate = this.getLocalStorageData('selectedDATimeFilter');
    if (daDate) {
      this.fromDate = daDate.startOfMonth;
      this.toDate = daDate.endOfMonth;
    } else {
      const currentDate = new Date();
      const initialDate = {
        appliedFilterType: 'month',
        dateObj: currentDate,
        selectedHr: {},
        endQuarterMonth: null,
        startOfMonth: moment(currentDate).subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        endOfMonth: moment(currentDate).subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
      };
      this.setLocalStorageData('selectedDATimeFilter', initialDate);
      this.fromDate = initialDate.startOfMonth;
      this.toDate = initialDate.endOfMonth;
    }
  }

  setLocalStorageData(key: string, data: any) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  setFactorySummary() {
    this.setDADate();
    this.selectedDACluster = this.getLocalStorageData('selectedDACluster');
    this.selectedDAFactory = this.getLocalStorageData('selectedDAFactory');
    let url = ``;
    this.showDashboard = true;
    if (this.selectedDAFactory.id.$oid) {
      url = `images/factories/${this.selectedDAFactory.id.$oid}`;
    }
    this.factorySummary = {
      clusterId: this.selectedDACluster.id,
      clusterName: this.selectedDACluster.subRegionName ? this.selectedDACluster.subRegionName : this.selectedDACluster.name,
      factoryId: this.selectedDAFactory.factoryId,
      factoryName: this.selectedDAFactory.name,
      factoryImage: '',
      fromDate: this.fromDate,
      toDate: this.toDate,
      level: 'factory',
      lineId: ''
    };

    this.updateQueryParams();

    this.factoryImageSubscription = this.daService.getFactoryImage(url)
      .subscribe(image => {
        this.factorySummary.factoryImage = image || 'assets/images/factory-placeholder.svg';
        // this.showDashboard = true;
      });
  }

  showFactorySelectionPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '400px';

    const dialogRef = this.dialog.open(FactorySelectionModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: { action: string, selectedData: any }) => {
      if (res.action === 'submitted' && res.selectedData) {
        this.setFactorySummary();
      }
    });
  }

  updateQueryParams() {
    this.isCurrentURLSaved = false;
    const queryParamsData: Params = {
      cluster: this.factorySummary.clusterId,
      factory: this.factorySummary.factoryId,
      FromDate: this.factorySummary.fromDate,
      ToDate: this.factorySummary.toDate,
      level: (this.level) ? this.level : 'factory'
    };
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParamsData,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });

    setTimeout(() => {
      this.updateFlagStatus();
    }, 100);
  }

  updateFlagStatus() {
    try {
      if (this.bookmarkList && this.bookmarkList.length > 0) {
        const routerIndex = this.bookmarkList.map(list => list.url).indexOf(window.location.href);
        if (routerIndex > -1) {
          this.isCurrentURLSaved = true;
        } else {
          this.isCurrentURLSaved = false;
        }
      }
    } catch (error) {

    }
  }

  getBookmarkData() {
    if (this.auth.checkIsAuthticated) {
      this.userDtls = this.authService.getAccount().userName;
    }
    this.daService.getBookmark({ createdby: this.userDtls })
      // .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.bookmarkList = [];
        if (data && data.length > 0) {
          this.bookmarkList = data;
          const routerIndex = this.bookmarkList.map(list => list.url).indexOf(window.location.href);
          if (routerIndex > -1) {
            this.isCurrentURLSaved = true;
          } else {
            this.isCurrentURLSaved = false;
          }
        } else {
          this.isCurrentURLSaved = false;
        }
      });
  }
  applyDateFilter(event) {
    if (event) {
      this.getBookmarkData();
      if (this.daRmPmComponent) {
        this.daRmPmComponent.onChangeDate(event.startOfMonth, event.endOfMonth);
      }
      // if (this.daTrendsComponent) {
      //   this.daTrendsComponent.onChangeDate(event.startOfMonth, event.endOfMonth);
      // }
      // if (this.daVolumeComponent) {
      //   this.daVolumeComponent.onChangeDate(event.startOfMonth, event.endOfMonth);
      // }
      // if (this.daCommentsComponent) {
      //   this.daCommentsComponent.onChangeDate(event.startOfMonth, event.endOfMonth);
      // }
      this.factorySummary.fromDate = event.startOfMonth;
      this.factorySummary.toDate = event.endOfMonth;
      this.updateQueryParams();

    }
  }

  toggleCommentBox(event) {
    this.isShowCommentBox = event;
  }

  getLatestDataRefreshDate() {
    this.latestDataRefreshDateSubscription = this.daService.getLatestDataRefreshDate()
      .subscribe(res => {
        if (res && res.result && res.result.refreshDateEpoch) {
          this.dataSer.setHeaderRefreshDataSubjectVal(Number(res.result.refreshDateEpoch));
        }
      });
  }

  ngOnDestroy() {
    this.daService.clearSelectedDA();
    if (this.actualConsumptionSubscription) {
      this.actualConsumptionSubscription.unsubscribe();
    }
    if (this.oeeAndChangeOverSubscription) {
      this.oeeAndChangeOverSubscription.unsubscribe();
    }
    if (this.factoryImageSubscription) {
      this.factoryImageSubscription.unsubscribe();
    }
    if (this.getBookmarkSubscription) {
      this.getBookmarkSubscription.unsubscribe();
    }
    if (this.latestDataRefreshDateSubscription) {
      this.latestDataRefreshDateSubscription.unsubscribe();
    }
  }
}
